import { Box, Button, Dialog, DialogContent, DialogTitle, Link, Modal, Typography } from '@material-ui/core';
import React, { useMemo,  useState } from 'react';

import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu';
import DataTable from '../../../../components/DataTable';
import { MAPEAMENTO_FILTERS, useMapeamentoCompetencias } from './useMapeamentoCompetencias';
import { format } from 'date-fns';
import QuestionAndAnswersModal from './QuestionAndAnswersModal';

export default function ListarMapeamentoV2() {
  const {
    data,
    filters,
    isLoading,
    page,
    rowsPerPage,
    changePage,
    changeFilters,
    changeRowsPerPage,
    refreshData,
    resetFilters
  } = useMapeamentoCompetencias();

  const [selectedMapeamento, setSelectedMapeamento] = useState(null);

  const rows = useMemo(() => {
    return data?.data?.map(row => {
      return {
        action: <Link underline="always" component="button" onClick={() => setSelectedMapeamento(row)}>RESPOSTAS</Link>,
        userID: row?.id,
        name: row?.nome,
        email: row?.email,
        registration_date: format(new Date(row?.data_answer), 'dd/MM/yyyy')
      }
    })
  }, [data]);

  const resetSelectedMapeamento = () => {
    setSelectedMapeamento(null);
  }

  const handleAiPepUpdated = async () => {
    await refreshData();
  };

  const handleAiPepDeleted = async () => {
    await refreshData(); 
    resetSelectedMapeamento(); 
  };

  return (
    <Box width="100%" paddingLeft="250px">
      <AdminMenu />
      <Box width="100%" padding="1rem">
        <DataTable
          showFilters
          showPagination
          maxHeight="70vh"
          hasStickHeader
          filters={[
            { key: MAPEAMENTO_FILTERS.USER, name: 'Aluno', component: { type: 'text' } },
            { key: MAPEAMENTO_FILTERS.MBA, name: 'MBA', component: { type: 'checkbox' } },
            { key: MAPEAMENTO_FILTERS.PAID, name: 'Pagantes', component: { type: 'checkbox' } },
            { key: MAPEAMENTO_FILTERS.PRO, name: 'Voitto PRO', component: { type: 'checkbox' } },
            { key: MAPEAMENTO_FILTERS.TRAIL, name: 'Trilha', component: { type: 'checkbox' } },
          ]}
          selectedFilters={filters}
          columns={[
            { key: 'action', name: '' },
            { key: 'userID', name: 'ID Aluno' },
            { key: 'name', name: 'Nome' },
            { key: 'email', name: 'Email' },
            { key: 'registration_date', name: 'Data registro' }
          ]}
          rows={rows}
          totalRecords={data?.count}
          page={page}
          rowsPerPage={rowsPerPage}
          isLoading={isLoading}
          onPageChange={changePage}
          onRowsPerChange={changeRowsPerPage}
          onSubmitFilters={changeFilters}
          onResetFilters={resetFilters}
          CustomToolbarElement={
            <Typography variant="h5" component="h1">Controle - Mapeamento de Competências</Typography>
          }
        />
        <QuestionAndAnswersModal selectedMapeamento={selectedMapeamento} open={!!selectedMapeamento} onClose={resetSelectedMapeamento} onAiPepUpdated={handleAiPepUpdated} onAiPepDeleted={handleAiPepDeleted} />
      </Box>
    </Box>
  );
}